'use strict';

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var errCode = require('err-code');

var extractDataFromBlock = require('../utils/extract-data-from-block.js');

var validateOffsetAndLength = require('../utils/validate-offset-and-length.js');

var mh = require('multiformats/hashes/digest');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n['default'] = e;
  return Object.freeze(n);
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var mh__namespace = /*#__PURE__*/_interopNamespace(mh);

var rawContent = function rawContent(node) {
  function contentGenerator() {
    return _contentGenerator.apply(this, arguments);
  }

  function _contentGenerator() {
    _contentGenerator = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          _validateOffsetAndLen,
          offset,
          length,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _validateOffsetAndLen = validateOffsetAndLength(node.length, options.offset, options.length), offset = _validateOffsetAndLen.offset, length = _validateOffsetAndLen.length;
              _context.next = 4;
              return extractDataFromBlock(node, 0, offset, offset + length);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _contentGenerator.apply(this, arguments);
  }

  return contentGenerator;
};

var resolve = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cid, name, path, toResolve, _resolve, depth, blockstore, options) {
    var buf;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!toResolve.length) {
              _context2.next = 2;
              break;
            }

            throw errCode__default['default'](new Error("No link named ".concat(path, " found in raw node ").concat(cid)), 'ERR_NOT_FOUND');

          case 2:
            _context2.next = 4;
            return mh__namespace.decode(cid.multihash.bytes);

          case 4:
            buf = _context2.sent;
            return _context2.abrupt("return", {
              entry: {
                type: 'identity',
                name: name,
                path: path,
                cid: cid,
                content: rawContent(buf.digest),
                depth: depth,
                size: buf.digest.length,
                node: buf.digest
              }
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function resolve(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = resolve;